package com.essntl.features.file.ui

import com.essntl.features.file.domain.model.FileModel

data class DeleteFileState(
    val files: List<FileModel> = emptyList(),
)
